export const MS3_PROVIDER_IDS = ['12843', '12839', '12842', '12841', '12840', '12844', '12848']
